module.exports = {
  showModalContent: () => {
    let content = document.querySelector('.modal-body > *');

    if (!!content) {
      content.classList.add('opacity-100');

      if (content.tagName === 'VIDEO') {
        content.play();
        // content.addEventListener('click', () => {
        //   if (content.paused) {
        //     content.play();
        //   } else {
        //     content.pause();
        //   }
        // });
      }
    }
  },
  hideModalContent: () => {
    let content = document.querySelector('.modal-body > *');

    if (!!content) {
      content.classList.remove('opacity-100');
    }
  }
}